import { defineComponent, reactive, computed, ref } from "vue";
import { myPageStore } from "~/store/MyPageStore";
import MyPageSelectBox from "~/components/MyPageSelectBox.vue";
import { isNullOrUndefined } from "~/extensions/utils/DefineFunction";
export default defineComponent({
    name: "BukenRoomList",
    components: {
        MyPageSelectBox
    },
    setup() {
        const personal = reactive(myPageStore.personal);
        const bukenRoomList = computed(() => personal.nyukyokeiyakuList.map(item => ({ label: `${item.bukkenNameWithRoom}`, value: item.orgNyukyokeiyakuNo })));
        const selectedRoom = ref(null);
        const index = computed(() => personal.nyukyokeiyakuList.findIndex(x => x.orgNyukyokeiyakuNo === myPageStore.selectedNyukyokeiyakuNo));
        //初期設定
        selectedRoom.value = bukenRoomList.value[index.value].value;
        const onChangeList = (selected) => {
            if (isNullOrUndefined(selected)) {
                return;
            }
            myPageStore.selectedNyukyokeiyakuNo = selected;
        };
        return {
            personal,
            bukenRoomList,
            selectedRoom,
            onChangeList
        };
    }
});
